import { __assign, __rest } from "tslib";
import React from 'react';
import styles from './styles.css.js';
function StaticNotifications(_a) {
    var children = _a.children, labels = _a.labels;
    return (React.createElement("div", { className: styles.notifications, role: "region", "aria-label": labels === null || labels === void 0 ? void 0 : labels.notifications }, children));
}
var StickyNotifications = React.forwardRef(function (props, ref) {
    return (React.createElement("div", { style: { top: props.topOffset }, className: styles['notifications-sticky'], ref: ref },
        React.createElement(StaticNotifications, __assign({}, props))));
});
export var Notifications = React.forwardRef(function (_a, ref) {
    var sticky = _a.sticky, rest = __rest(_a, ["sticky"]);
    return sticky ? React.createElement(StickyNotifications, __assign({}, rest, { ref: ref })) : React.createElement(StaticNotifications, __assign({}, rest));
});
//# sourceMappingURL=notifications.js.map